import styled from 'styled-components';

export const Container = styled.div`
    min-width: 320px;
    color: var(--text-primary);
`;
